import { useEffect, useState } from 'react';
import axios from 'axios';

type HomepageData = {
	publishedYears: string;
	numberOfPagesOfNameRegisters: string;
	numberOfPagesOfOperates: string;
};

const useHomepage = () => {
	const [data, setData] = useState<HomepageData>();

	useEffect(() => {
		axios.get('api/scitacioperaty/home').then(response => {
			if (response.data) {
				setData(response.data);
			}
		});
	}, []);

	return {
		data,
	};
};

export default useHomepage;
